import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["Quantity"],
  _excluded2 = ["custom"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.sort.js";
// src/line-item-helper/line-item-helper.ts
import { keyValueObjectToStringArray } from "@printdeal/transformers";

// src/custom-line-item-helper/custom-line-item-helper.ts
var CustomLineItemHelper = class _CustomLineItemHelper {
  static isCustomLineItemOfType(customLineItem, type) {
    var _customLineItem$custo;
    return ((_customLineItem$custo = customLineItem.custom) === null || _customLineItem$custo === void 0 ? void 0 : _customLineItem$custo.fields.lineItemType) === type;
  }
  static getCustomLineItemsOfType(customLineItems, type) {
    return customLineItems.filter(customLineItem => this.isCustomLineItemOfType(customLineItem, type));
  }
  static getCustomLineItemsByLineItemReference(customLineItems, lineItemId) {
    return customLineItems.filter(customLineItem => {
      var _customLineItem$custo2;
      return ((_customLineItem$custo2 = customLineItem.custom) === null || _customLineItem$custo2 === void 0 ? void 0 : _customLineItem$custo2.fields.lineItemReference) === lineItemId;
    });
  }
  static getAssociatedCustomLineItems(customLineItems, lineItemId, type) {
    const associatedCustomLineItems = _CustomLineItemHelper.getCustomLineItemsByLineItemReference(customLineItems, lineItemId);
    if (type) {
      return associatedCustomLineItems.filter(customLineItem => _CustomLineItemHelper.isCustomLineItemOfType(customLineItem, type));
    }
    return associatedCustomLineItems;
  }
  static getCustomLineItemEcommerceDeliveryOptionId(customLineItem) {
    var _customLineItem$custo3;
    return (_customLineItem$custo3 = customLineItem.custom) === null || _customLineItem$custo3 === void 0 ? void 0 : _customLineItem$custo3.fields.eCommerceDeliveryOptionId;
  }
  static getCustomLineItemsOfServiceName(customLineItems, lineItemId, serviceNames) {
    return _CustomLineItemHelper.getAssociatedCustomLineItems(customLineItems, lineItemId, "service").filter(customLineItem => {
      var _customLineItem$custo4;
      return ((_customLineItem$custo4 = customLineItem.custom) === null || _customLineItem$custo4 === void 0 ? void 0 : _customLineItem$custo4.fields.serviceName) && serviceNames.includes(customLineItem.custom.fields.serviceName);
    });
  }
  static hasState(customLineItem, statesKeys) {
    var _state$state$obj;
    const [state] = customLineItem.state;
    const stateKey = state === null || state === void 0 || (_state$state$obj = state.state.obj) === null || _state$state$obj === void 0 ? void 0 : _state$state$obj.key;
    if (!stateKey) {
      return false;
    }
    return statesKeys.includes(stateKey);
  }
  static isCancelled(customLineItem) {
    return _CustomLineItemHelper.hasState(customLineItem, ["Cancelled"]);
  }
  static isActive(customLineItem) {
    return !_CustomLineItemHelper.isCancelled(customLineItem);
  }
};

// src/line-item-helper/line-item-helper.ts
var LineItemHelper = class _LineItemHelper {
  static hasLineItemReviewGroup(lineItem) {
    var _lineItem$custom;
    return Boolean((_lineItem$custom = lineItem.custom) === null || _lineItem$custom === void 0 ? void 0 : _lineItem$custom.fields.reviewGroup);
  }
  static isLineItemReviewGroupLead(lineItem) {
    var _lineItem$custom2;
    return Boolean((_lineItem$custom2 = lineItem.custom) === null || _lineItem$custom2 === void 0 ? void 0 : _lineItem$custom2.fields.isReviewGroupLead);
  }
  static isLineItemReviewGroupMember(lineItem, groupId) {
    var _lineItem$custom3;
    return ((_lineItem$custom3 = lineItem.custom) === null || _lineItem$custom3 === void 0 ? void 0 : _lineItem$custom3.fields.reviewGroup) === groupId;
  }
  static hasLineItemMultipleDesignsGroup(lineItem) {
    var _lineItem$custom4;
    return Boolean((_lineItem$custom4 = lineItem.custom) === null || _lineItem$custom4 === void 0 ? void 0 : _lineItem$custom4.fields.multipleDesignsGroup);
  }
  static isLineItemMultipleDesignsGroupMember(lineItem, groupId) {
    var _lineItem$custom5;
    return ((_lineItem$custom5 = lineItem.custom) === null || _lineItem$custom5 === void 0 ? void 0 : _lineItem$custom5.fields.multipleDesignsGroup) === groupId;
  }
  static hasLineItemOrchestrationsGroup(lineItem) {
    var _lineItem$custom6;
    return Boolean((_lineItem$custom6 = lineItem.custom) === null || _lineItem$custom6 === void 0 ? void 0 : _lineItem$custom6.fields.orchestrationId);
  }
  static isLineItemOrchestrationsGroupLead(lineItem) {
    var _lineItem$custom7;
    return Boolean(((_lineItem$custom7 = lineItem.custom) === null || _lineItem$custom7 === void 0 ? void 0 : _lineItem$custom7.fields.orchestration) && lineItem.custom.fields.recipient === "customer");
  }
  static isLineItemOrchestrationsGroupMember(lineItem, orchestrationId) {
    var _lineItem$custom8;
    return ((_lineItem$custom8 = lineItem.custom) === null || _lineItem$custom8 === void 0 ? void 0 : _lineItem$custom8.fields.orchestrationId) === orchestrationId;
  }
  static getLineItemGroupType(lineItem) {
    if (_LineItemHelper.hasLineItemReviewGroup(lineItem)) {
      return "textile";
    }
    if (_LineItemHelper.hasLineItemMultipleDesignsGroup(lineItem)) {
      return "multipleDesigns";
    }
    return void 0;
  }
  static isLineItemGrouped(lineItem) {
    return _LineItemHelper.hasLineItemReviewGroup(lineItem) || _LineItemHelper.hasLineItemMultipleDesignsGroup(lineItem) || _LineItemHelper.hasLineItemOrchestrationsGroup(lineItem);
  }
  static getLineItemQuantity(entity, lineItem) {
    if (_LineItemHelper.isLineItemReviewGroupLead(lineItem)) {
      const reviewGroup = EntityHelper.getReviewGroup(entity, lineItem.custom.fields.reviewGroup);
      return reviewGroup.reduce((acc, lineItem2) => acc + lineItem2.quantity, 0);
    }
    if (_LineItemHelper.hasLineItemMultipleDesignsGroup(lineItem)) {
      const multipleDesignsGroup = EntityHelper.getMultipleDesignsGroup(entity, lineItem.custom.fields.multipleDesignsGroup);
      return multipleDesignsGroup.reduce((acc, lineItem2) => acc + lineItem2.quantity, 0);
    }
    return lineItem.quantity;
  }
  static isLineItemQuote(lineItem) {
    var _lineItem$custom9;
    return Boolean((_lineItem$custom9 = lineItem.custom) === null || _lineItem$custom9 === void 0 ? void 0 : _lineItem$custom9.fields.quoteId);
  }
  static hasLineItemPickupPoint(lineItem) {
    var _lineItem$custom10;
    return Boolean(((_lineItem$custom10 = lineItem.custom) === null || _lineItem$custom10 === void 0 ? void 0 : _lineItem$custom10.fields.isWithPickupLocation) && lineItem.custom.fields.pickupPoint);
  }
  static hasLineItemTimedDelivery(lineItem) {
    var _lineItem$custom11;
    return Boolean((_lineItem$custom11 = lineItem.custom) === null || _lineItem$custom11 === void 0 ? void 0 : _lineItem$custom11.fields.timedDelivery);
  }
  static hasLineItemSplitShipment(lineItem) {
    var _lineItem$custom12;
    return Boolean(((_lineItem$custom12 = lineItem.custom) === null || _lineItem$custom12 === void 0 || (_lineItem$custom12 = _lineItem$custom12.fields.shippingAddressPerLineItem) === null || _lineItem$custom12 === void 0 ? void 0 : _lineItem$custom12.length) && lineItem.custom.fields.shippingAddressPerLineItem.length > 1);
  }
  static getLineItemShippingAddresses(lineItem) {
    var _lineItem$custom13;
    if (!((_lineItem$custom13 = lineItem.custom) !== null && _lineItem$custom13 !== void 0 && _lineItem$custom13.fields.shippingAddressPerLineItem)) {
      return void 0;
    }
    return lineItem.custom.fields.shippingAddressPerLineItem.map(address => {
      return keyValueObjectToStringArray(address);
    });
  }
  static getLineItemPickupPointId(lineItem) {
    if (!_LineItemHelper.hasLineItemPickupPoint(lineItem)) {
      return void 0;
    }
    try {
      var _pickupPoint$href;
      const [pickupPoint] = JSON.parse(lineItem.custom.fields.pickupPoint);
      if (!((_pickupPoint$href = pickupPoint.href) !== null && _pickupPoint$href !== void 0 && _pickupPoint$href.includes("/v1/pickupPoints/"))) {
        return void 0;
      }
      const pickupPointId = pickupPoint.href.split("/v1/pickupPoints/").pop();
      return pickupPointId ? decodeURIComponent(pickupPointId) : void 0;
    } catch (_unused) {
      return void 0;
    }
  }
  static hasState(lineItem, statesKeys) {
    var _state$state$obj2;
    const [state] = lineItem.state;
    const stateKey = state === null || state === void 0 || (_state$state$obj2 = state.state.obj) === null || _state$state$obj2 === void 0 ? void 0 : _state$state$obj2.key;
    if (!stateKey) {
      return false;
    }
    return statesKeys.includes(stateKey);
  }
  static isCancelled(lineItem) {
    return _LineItemHelper.hasState(lineItem, ["Cancelled"]);
  }
  static isCancellable(lineItem) {
    return _LineItemHelper.hasState(lineItem, ["Initial", "Processing", "Confirmed", "Held", "WaitingForArtwork", "DocReviewFailed", "DocReviewRejected", "ProcessingCloudlabArtworkFailed", "ProcessingCloudlabArtwork"]);
  }
  static isShipped(lineItem) {
    return _LineItemHelper.hasState(lineItem, ["Shipped"]);
  }
  static isComplainable(lineItem) {
    var _lineItem$custom14;
    return ((_lineItem$custom14 = lineItem.custom) === null || _lineItem$custom14 === void 0 ? void 0 : _lineItem$custom14.fields.mcpFulfillmentLineItemId) !== void 0;
  }
  static shouldRecalculatePromisedArrivalDate(lineItem) {
    return !_LineItemHelper.hasState(lineItem, ["ReadyForFulfillment", "FulfillmentAccepted", "PrintingInProgress", "Shipped", "Cancelled", "SentToMCP"]);
  }
  static isArtworkRequired(lineItem) {
    var _lineItem$custom15;
    if (_LineItemHelper.isCancelled(lineItem)) {
      return false;
    }
    return ((_lineItem$custom15 = lineItem.custom) === null || _lineItem$custom15 === void 0 || (_lineItem$custom15 = _lineItem$custom15.fields.artworkRequired) === null || _lineItem$custom15 === void 0 ? void 0 : _lineItem$custom15.trim().toLowerCase()) === "yes";
  }
  static isArtworkDelivered(lineItem) {
    var _lineItem$custom16, _lineItem$custom17, _lineItem$custom18, _lineItem$custom$fiel, _lineItem$custom19, _lineItem$custom20;
    if ((_lineItem$custom16 = lineItem.custom) !== null && _lineItem$custom16 !== void 0 && _lineItem$custom16.fields.artworkUploadURL) {
      return true;
    }
    if ((_lineItem$custom17 = lineItem.custom) !== null && _lineItem$custom17 !== void 0 && _lineItem$custom17.fields.manufacturingReadyDocumentUrl) {
      return true;
    }
    if ((_lineItem$custom18 = lineItem.custom) !== null && _lineItem$custom18 !== void 0 && _lineItem$custom18.fields.mcpDocumentsSource && lineItem.custom.fields.userUploadComplete) {
      return true;
    }
    if (((_lineItem$custom$fiel = (_lineItem$custom19 = lineItem.custom) === null || _lineItem$custom19 === void 0 || (_lineItem$custom19 = _lineItem$custom19.fields.userUploadsUrl) === null || _lineItem$custom19 === void 0 ? void 0 : _lineItem$custom19.length) !== null && _lineItem$custom$fiel !== void 0 ? _lineItem$custom$fiel : 0) > 0 && (_lineItem$custom20 = lineItem.custom) !== null && _lineItem$custom20 !== void 0 && _lineItem$custom20.fields.userUploadComplete) {
      return true;
    }
    return false;
  }
  static isEditable(lineItem, customLineItems) {
    if (_LineItemHelper.isLineItemGrouped(lineItem)) {
      return false;
    }
    if (_LineItemHelper.isLineItemQuote(lineItem)) {
      return false;
    }
    if (_LineItemHelper.hasLineItemSplitShipment(lineItem) || _LineItemHelper.hasLineItemPickupPoint(lineItem)) {
      return false;
    }
    const fileServices = CustomLineItemHelper.getCustomLineItemsOfServiceName(customLineItems, lineItem.id, ["File Check", "File Design", "File Change"]);
    const hasActiveFileServices = fileServices.some(fileService => {
      return CustomLineItemHelper.hasState(fileService, ["EditInProgress", "ServiceInProgress", "ServiceDelivered", "Cancelled"]);
    });
    if (hasActiveFileServices) {
      return false;
    }
    return !_LineItemHelper.hasState(lineItem, ["FulfillmentRejected", "FulfillmentAccepted", "FulfillmentError", "PrintingInProgress", "DocReviewInProgress", "WaitingForDocReview", "WaitingForSecondaryDocReview", "Shipped", "Cancelled", "SentToMCP", "Held", "ProcessingCloudlabArtwork", "PreparingDocForReview", "InStandardReview"]);
  }
};

// src/entity-helper/entity-helper.ts
import { arrayOfStringArraysToArrayOfObjects } from "@printdeal/transformers";
var EntityHelper = class _EntityHelper {
  static isCart(entity) {
    return "cartState" in entity;
  }
  static isOrder(entity) {
    return "orderState" in entity;
  }
  static getMainLineItems(entity) {
    const filteredLineItems = entity.lineItems.filter(lineItem => {
      if (!LineItemHelper.hasLineItemReviewGroup(lineItem)) {
        return true;
      }
      return LineItemHelper.isLineItemReviewGroupLead(lineItem);
    });
    const seenMultipleDesignGroups = /* @__PURE__ */new Set();
    return filteredLineItems.filter(lineItem => {
      var _lineItem$custom21;
      const multipleDesignsGroup = (_lineItem$custom21 = lineItem.custom) === null || _lineItem$custom21 === void 0 ? void 0 : _lineItem$custom21.fields.multipleDesignsGroup;
      if (!multipleDesignsGroup) {
        return true;
      }
      if (seenMultipleDesignGroups.has(multipleDesignsGroup)) {
        return false;
      }
      seenMultipleDesignGroups.add(multipleDesignsGroup);
      return true;
    });
  }
  static getVisibleCartChangeAfterLogin(cartBeforeLogin, cartAfterLogin) {
    const didCartChange = cartAfterLogin && cartAfterLogin.id !== (cartBeforeLogin === null || cartBeforeLogin === void 0 ? void 0 : cartBeforeLogin.id);
    const mainLineItemsBeforeLogin = cartBeforeLogin ? _EntityHelper.getMainLineItems(cartBeforeLogin) : [];
    const mainLineItemsAfterLogin = cartAfterLogin ? _EntityHelper.getMainLineItems(cartAfterLogin) : [];
    if (didCartChange && mainLineItemsAfterLogin.length) {
      if (!cartBeforeLogin) {
        return "retrievedCart";
      }
      if (mainLineItemsAfterLogin.length > mainLineItemsBeforeLogin.length) {
        return "mergedCart";
      }
    }
    return "none";
  }
  static getReviewGroup(entity, groupId) {
    return entity.lineItems.filter(lineItem => LineItemHelper.isLineItemReviewGroupMember(lineItem, groupId));
  }
  static getMultipleDesignsGroup(entity, groupId) {
    return entity.lineItems.filter(lineItem => LineItemHelper.isLineItemMultipleDesignsGroupMember(lineItem, groupId));
  }
  static getLastUpdatedPayment(entity) {
    var _entity$paymentInfo, _sort$shift;
    if (!((_entity$paymentInfo = entity.paymentInfo) !== null && _entity$paymentInfo !== void 0 && _entity$paymentInfo.payments.length)) {
      return void 0;
    }
    return (_sort$shift = [...entity.paymentInfo.payments].sort((a, b) => {
      var _a$obj$lastModifiedAt, _a$obj, _b$obj$lastModifiedAt, _b$obj;
      const aDate = new Date((_a$obj$lastModifiedAt = (_a$obj = a.obj) === null || _a$obj === void 0 ? void 0 : _a$obj.lastModifiedAt) !== null && _a$obj$lastModifiedAt !== void 0 ? _a$obj$lastModifiedAt : "");
      const bDate = new Date((_b$obj$lastModifiedAt = (_b$obj = b.obj) === null || _b$obj === void 0 ? void 0 : _b$obj.lastModifiedAt) !== null && _b$obj$lastModifiedAt !== void 0 ? _b$obj$lastModifiedAt : "");
      return bDate.getTime() - aDate.getTime();
    }).shift()) === null || _sort$shift === void 0 ? void 0 : _sort$shift.obj;
  }
  static getLastAddedShippingAddress(entity) {
    var _latestModifiedLineIt;
    const lineItems = entity.lineItems.filter(lineItem => !LineItemHelper.hasLineItemPickupPoint(lineItem));
    if (!lineItems.length) {
      return void 0;
    }
    const latestModifiedLineItem = lineItems.sort((a, b) => {
      var _a$lastModifiedAt, _b$lastModifiedAt;
      const aDate = new Date((_a$lastModifiedAt = a.lastModifiedAt) !== null && _a$lastModifiedAt !== void 0 ? _a$lastModifiedAt : "");
      const bDate = new Date((_b$lastModifiedAt = b.lastModifiedAt) !== null && _b$lastModifiedAt !== void 0 ? _b$lastModifiedAt : "");
      return bDate.getTime() - aDate.getTime();
    }).shift();
    if (!(latestModifiedLineItem !== null && latestModifiedLineItem !== void 0 && (_latestModifiedLineIt = latestModifiedLineItem.custom) !== null && _latestModifiedLineIt !== void 0 && (_latestModifiedLineIt = _latestModifiedLineIt.fields.shippingAddressPerLineItem) !== null && _latestModifiedLineIt !== void 0 && _latestModifiedLineIt.length)) {
      return void 0;
    }
    const [shippingAddress] = arrayOfStringArraysToArrayOfObjects(latestModifiedLineItem.custom.fields.shippingAddressPerLineItem);
    if (shippingAddress) {
      delete shippingAddress.quantity;
    }
    return shippingAddress;
  }
  // TODO: Check with Bjorn/Rogier if we need this method and reuse getMainLineItems instead
  static getMainGroupedLineItems(entity) {
    const seenMultipleDesignsGroups = /* @__PURE__ */new Set();
    return entity.lineItems.filter(lineItem => {
      if (!LineItemHelper.isLineItemGrouped(lineItem)) {
        return true;
      }
      if (LineItemHelper.isLineItemOrchestrationsGroupLead(lineItem)) {
        return true;
      }
      if (LineItemHelper.isLineItemReviewGroupLead(lineItem)) {
        return true;
      }
      if (LineItemHelper.hasLineItemMultipleDesignsGroup(lineItem)) {
        const multipleDesignsGroup = lineItem.custom.fields.multipleDesignsGroup;
        if (seenMultipleDesignsGroups.has(multipleDesignsGroup)) {
          return false;
        }
        seenMultipleDesignsGroups.add(multipleDesignsGroup);
        return true;
      }
      return false;
    });
  }
  static hasQuoteLineItems(entity) {
    return entity.lineItems.some(lineItem => LineItemHelper.isLineItemQuote(lineItem));
  }
  static hasPaymentInfo(entity) {
    var _entity$paymentInfo2;
    return Boolean((_entity$paymentInfo2 = entity.paymentInfo) === null || _entity$paymentInfo2 === void 0 ? void 0 : _entity$paymentInfo2.payments.length);
  }
  static getNextLineItemNumber(entity) {
    let highestNumber = 0;
    [...entity.lineItems, ...entity.customLineItems].forEach(item => {
      var _item$custom;
      if ((_item$custom = item.custom) !== null && _item$custom !== void 0 && _item$custom.fields.lineItemNumber) {
        const parts = item.custom.fields.lineItemNumber.split("-");
        const lastPart = parts.pop();
        if (lastPart && /^\d+$/.test(lastPart)) {
          const number = Number(lastPart);
          highestNumber = Math.max(highestNumber, number);
        }
      }
    });
    return highestNumber + 1;
  }
  static findLineItemInEntity(entity, lineItemId) {
    return entity.lineItems.find(lineItem => lineItem.id === lineItemId);
  }
  static getGroupedLineItems(entity, lineItemId) {
    const lineItem = _EntityHelper.findLineItemInEntity(entity, lineItemId);
    if (!lineItem) {
      return [];
    }
    if (LineItemHelper.hasLineItemReviewGroup(lineItem)) {
      const reviewGroupId = lineItem.custom.fields.reviewGroup;
      return entity.lineItems.filter(lineItem2 => LineItemHelper.isLineItemReviewGroupMember(lineItem2, reviewGroupId));
    }
    if (LineItemHelper.hasLineItemMultipleDesignsGroup(lineItem)) {
      const multipleDesignsGroupId = lineItem.custom.fields.multipleDesignsGroup;
      return entity.lineItems.filter(lineItem2 => LineItemHelper.isLineItemMultipleDesignsGroupMember(lineItem2, multipleDesignsGroupId));
    }
    if (LineItemHelper.hasLineItemOrchestrationsGroup(lineItem)) {
      const orchestrationId = lineItem.custom.fields.orchestrationId;
      return entity.lineItems.filter(item => LineItemHelper.isLineItemOrchestrationsGroupMember(item, orchestrationId));
    }
    return [lineItem];
  }
  static getActiveTaxedPrice(entity) {
    const cancelledLineItems = entity.lineItems.filter(lineItem => LineItemHelper.isCancelled(lineItem));
    const cancelledCustomLineItems = entity.customLineItems.filter(customLineItem => CustomLineItemHelper.isCancelled(customLineItem));
    const taxedPrice = [...cancelledLineItems, ...cancelledCustomLineItems].reduce((acc, lineItem) => {
      var _lineItem$taxedPrice$, _lineItem$taxedPrice, _lineItem$taxedPrice$2, _lineItem$taxedPrice2, _lineItem$taxedPrice$3, _lineItem$taxedPrice3;
      if (!acc) {
        return void 0;
      }
      return _objectSpread(_objectSpread({
        totalNet: _objectSpread(_objectSpread({}, acc.totalNet), {}, {
          centAmount: acc.totalNet.centAmount - ((_lineItem$taxedPrice$ = (_lineItem$taxedPrice = lineItem.taxedPrice) === null || _lineItem$taxedPrice === void 0 ? void 0 : _lineItem$taxedPrice.totalNet.centAmount) !== null && _lineItem$taxedPrice$ !== void 0 ? _lineItem$taxedPrice$ : 0)
        }),
        totalGross: _objectSpread(_objectSpread({}, acc.totalGross), {}, {
          centAmount: acc.totalGross.centAmount - ((_lineItem$taxedPrice$2 = (_lineItem$taxedPrice2 = lineItem.taxedPrice) === null || _lineItem$taxedPrice2 === void 0 ? void 0 : _lineItem$taxedPrice2.totalGross.centAmount) !== null && _lineItem$taxedPrice$2 !== void 0 ? _lineItem$taxedPrice$2 : 0)
        })
      }, acc.totalTax && {
        totalTax: _objectSpread(_objectSpread({}, acc.totalTax), {}, {
          centAmount: acc.totalTax.centAmount - ((_lineItem$taxedPrice$3 = (_lineItem$taxedPrice3 = lineItem.taxedPrice) === null || _lineItem$taxedPrice3 === void 0 || (_lineItem$taxedPrice3 = _lineItem$taxedPrice3.totalTax) === null || _lineItem$taxedPrice3 === void 0 ? void 0 : _lineItem$taxedPrice3.centAmount) !== null && _lineItem$taxedPrice$3 !== void 0 ? _lineItem$taxedPrice$3 : 0)
        })
      }), {}, {
        taxPortions: acc.taxPortions.map(originalPortion => {
          var _lineItem$taxedPrice$4, _lineItem$taxedPrice4;
          const taxPortions = (_lineItem$taxedPrice$4 = (_lineItem$taxedPrice4 = lineItem.taxedPrice) === null || _lineItem$taxedPrice4 === void 0 ? void 0 : _lineItem$taxedPrice4.taxPortions) !== null && _lineItem$taxedPrice$4 !== void 0 ? _lineItem$taxedPrice$4 : [];
          const matchingPortions = taxPortions.filter(cancelledPortion => {
            return cancelledPortion.name === originalPortion.name && cancelledPortion.rate === originalPortion.rate;
          });
          return _objectSpread(_objectSpread({}, originalPortion), {}, {
            amount: _objectSpread(_objectSpread({}, originalPortion.amount), {}, {
              centAmount: originalPortion.amount.centAmount - matchingPortions.reduce((sum, portion) => sum + portion.amount.centAmount, 0)
            })
          });
        }).filter(portion => portion.amount.centAmount > 0)
      });
    }, entity.taxedPrice);
    return taxedPrice;
  }
};

// src/action-helper/action-helper.ts
var ActionHelper = class {
  constructor(entity, actions) {
    this.entity = entity;
    this.actions = actions;
  }
  setCustomField(action, fieldName, fieldValue) {
    var _action$custom, _action$custom2;
    return _objectSpread(_objectSpread({}, action), {}, {
      custom: {
        type: _objectSpread({
          typeId: "type"
        }, (_action$custom = action.custom) === null || _action$custom === void 0 ? void 0 : _action$custom.type),
        fields: _objectSpread(_objectSpread({}, (_action$custom2 = action.custom) === null || _action$custom2 === void 0 ? void 0 : _action$custom2.fields), {}, {
          [fieldName]: fieldValue
        })
      }
    });
  }
  generateLineItemNumber() {
    if (!EntityHelper.isOrder(this.entity) || !this.entity.orderNumber) {
      return;
    }
    let nextNumber = EntityHelper.getNextLineItemNumber(this.entity);
    const {
      orderNumber
    } = this.entity;
    this.actions.forEach((action, index) => {
      var _action$custom3;
      if ((action.action === "addLineItem" || action.action === "addCustomLineItem") && !((_action$custom3 = action.custom) !== null && _action$custom3 !== void 0 && (_action$custom3 = _action$custom3.fields) !== null && _action$custom3 !== void 0 && _action$custom3.lineItemNumber)) {
        let updatedAction = this.setCustomField(action, "lineItemNumber", "".concat(orderNumber, "-").concat(nextNumber.toString()));
        if (action.action === "addLineItem") {
          updatedAction = this.setCustomField(updatedAction, "merchantShippingReference", "".concat(orderNumber, "-").concat(nextNumber.toString()));
        }
        this.actions[index] = updatedAction;
        nextNumber += 1;
      }
    });
  }
  mergeGeneratedActions() {
    const lineItemIds = [...this.entity.lineItems.map(_ref => {
      let {
        id
      } = _ref;
      return id;
    }), ...this.entity.customLineItems.map(_ref2 => {
      let {
        id
      } = _ref2;
      return id;
    })];
    const actionsToDelete = [];
    this.actions.forEach(action => {
      let actionLineItemId;
      if ("lineItemId" in action && action.lineItemId) {
        actionLineItemId = action.lineItemId;
      }
      if ("customLineItemId" in action && action.customLineItemId) {
        actionLineItemId = action.customLineItemId;
      }
      if (actionLineItemId && !lineItemIds.includes(actionLineItemId)) {
        const foundAction = this.actions.find(ac => ac.action === "addLineItem" || ac.action === "addCustomLineItem");
        if (foundAction) {
          const index = this.actions.indexOf(foundAction);
          if ("name" in action && "value" in action) {
            this.actions[index] = this.setCustomField(foundAction, action.name, action.value);
            actionsToDelete.push(action);
          }
          if ("money" in action && foundAction.action === "addCustomLineItem") {
            this.actions[index] = _objectSpread(_objectSpread({}, foundAction), {}, {
              money: action.money
            });
            actionsToDelete.push(action);
          }
          if ("externalPrice" in action && foundAction.action === "addLineItem") {
            this.actions[index] = _objectSpread(_objectSpread({}, foundAction), {}, {
              externalPrice: action.externalPrice
            });
            actionsToDelete.push(action);
          }
          if ("externalTaxRate" in action) {
            this.actions[index] = _objectSpread(_objectSpread({}, foundAction), {}, {
              externalTaxRate: action.externalTaxRate
            });
            actionsToDelete.push(action);
          }
        }
      }
    });
    this.actions = this.actions.filter(ac => !actionsToDelete.includes(ac));
  }
  cleanCustomLineItemActions() {
    this.actions.forEach(action => {
      if (action.action === "removeCustomLineItem" && "customLineItemId" in action && action.customLineItemId) {
        const {
          customLineItemId
        } = action;
        this.actions = this.actions.filter(lineAction => {
          if ("customLineItemId" in lineAction && lineAction.customLineItemId === customLineItemId) {
            return lineAction.action === "removeCustomLineItem";
          }
          return true;
        });
      }
    });
  }
  collect() {
    this.generateLineItemNumber();
    this.mergeGeneratedActions();
    this.cleanCustomLineItemActions();
    return this.actions;
  }
};

// src/add-line-item-helper/add-line-item-helper.ts
import { getLinkedServices } from "@printdeal/business-logic";
import { keyValueObjectToStringArray as keyValueObjectToStringArray2 } from "@printdeal/transformers";
var AddLineItemHelper = class _AddLineItemHelper {
  static buildLineItemShape(properties) {
    var _properties$quantity;
    const {
        userSelection: {
          Quantity: quantity
        }
      } = properties,
      userSelection = _objectWithoutProperties(properties.userSelection, _excluded);
    if (!properties.productVersion && !properties.variantSku || properties.productVersion && properties.variantSku) {
      throw new Error('Either "productVersion" or "variantSku" must be provided, not both.');
    }
    return _objectSpread(_objectSpread(_objectSpread({
      quantity: (_properties$quantity = properties.quantity) !== null && _properties$quantity !== void 0 ? _properties$quantity : Number(quantity),
      product: _objectSpread(_objectSpread(_objectSpread({
        productId: properties.productId,
        productKey: properties.productKey
      }, properties.productVersion && {
        productVersion: properties.productVersion
      }), properties.variantSku && {
        variantSku: properties.variantSku
      }), {}, {
        userSelection
      })
    }, properties.deliveryOptionId && {
      shipping: {
        deliveryOptionId: properties.deliveryOptionId
      }
    }), {}, {
      services: properties.services,
      reorderOriginalLineItemNumber: properties.reorderOriginalLineItemNumber,
      files: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (properties.documentReferenceUrl || properties.mcpDocumentsSource) && {
        mcp: {
          mcpDocumentsSource: properties.documentReferenceUrl ? ["DocumentReferenceUrl:".concat(properties.documentReferenceUrl)] : properties.mcpDocumentsSource
        }
      }), (properties.manufacturingReadyDocumentUrl || properties.mrdMetadata) && {
        manufacturingReadyDocument: {
          url: properties.manufacturingReadyDocumentUrl,
          metadata: properties.mrdMetadata
        }
      }), properties.userUploadsUrl && {
        userUploadsUrl: properties.userUploadsUrl
      }), {}, {
        editorType: properties.editorType
      })
    }, (properties.skipReview || properties.groupId || properties.isGroupLead) && {
      review: _objectSpread(_objectSpread({}, properties.skipReview && {
        skip: properties.skipReview
      }), properties.groupId && {
        group: _objectSpread({
          id: properties.groupId
        }, properties.isGroupLead && {
          isLead: properties.isGroupLead
        })
      })
    }), {}, {
      fulfillmentGroupId: properties.fulfillmentGroupId,
      multipleDesignsGroup: properties.multipleDesignsGroup
    }, properties.orchestration && {
      orchestration: properties.orchestration
    });
  }
  static buildLineItemShapeFromLineItems(_ref3) {
    let {
      orderOrCart,
      lineItems,
      isReorder = false,
      isWithFile = false,
      artworks
    } = _ref3;
    return {
      lineItems: lineItems.map(lineItem => {
        var _lineItem$custom22, _lineItem$custom23, _lineItem$custom24, _lineItem$custom25, _lineItem$custom26, _lineItem$custom27, _lineItem$custom28, _lineItem$custom29, _lineItem$custom30, _lineItem$custom31, _lineItem$custom32, _lineItem$custom33, _shippingCustomLineIt, _lineItem$custom34, _lineItem$custom35, _lineItem$custom36, _lineItem$custom37, _lineItem$custom38;
        const servicesLineItems = getLinkedServices(lineItem.id, orderOrCart);
        const servicesKeys = servicesLineItems.length > 0 ? servicesLineItems.map(serviceLineItem => serviceLineItem.custom.fields.serviceKey) : void 0;
        const orchestration = (_lineItem$custom22 = lineItem.custom) !== null && _lineItem$custom22 !== void 0 && _lineItem$custom22.fields.orchestration ? JSON.parse(lineItem.custom.fields.orchestration) : void 0;
        const [shippingCustomLineItem] = CustomLineItemHelper.getAssociatedCustomLineItems(orderOrCart.customLineItems, lineItem.id, "shipping");
        const artwork = artworks === null || artworks === void 0 ? void 0 : artworks.find(artwork2 => artwork2.lineItemId === lineItem.id);
        return _AddLineItemHelper.buildLineItemShape(_objectSpread(_objectSpread(_objectSpread({
          quantity: lineItem.quantity,
          productId: (_lineItem$custom23 = lineItem.custom) === null || _lineItem$custom23 === void 0 ? void 0 : _lineItem$custom23.fields.contentfulPageId,
          productKey: (_lineItem$custom24 = lineItem.custom) === null || _lineItem$custom24 === void 0 ? void 0 : _lineItem$custom24.fields.productKey,
          userSelection: keyValueObjectToStringArray2((_lineItem$custom25 = lineItem.custom) === null || _lineItem$custom25 === void 0 ? void 0 : _lineItem$custom25.fields.userSelection),
          productVersion: (_lineItem$custom26 = lineItem.custom) === null || _lineItem$custom26 === void 0 ? void 0 : _lineItem$custom26.fields.MMProductVersion,
          variantSku: lineItem.variant.sku,
          services: isReorder ? void 0 : servicesKeys,
          groupId: (_lineItem$custom27 = lineItem.custom) === null || _lineItem$custom27 === void 0 ? void 0 : _lineItem$custom27.fields.reviewGroup,
          isGroupLead: (_lineItem$custom28 = lineItem.custom) === null || _lineItem$custom28 === void 0 ? void 0 : _lineItem$custom28.fields.isReviewGroupLead,
          multipleDesignsGroup: (_lineItem$custom29 = lineItem.custom) === null || _lineItem$custom29 === void 0 ? void 0 : _lineItem$custom29.fields.multipleDesignsGroup,
          skipReview: (_lineItem$custom30 = lineItem.custom) === null || _lineItem$custom30 === void 0 ? void 0 : _lineItem$custom30.fields.skipReview,
          fulfillmentGroupId: (_lineItem$custom31 = lineItem.custom) === null || _lineItem$custom31 === void 0 ? void 0 : _lineItem$custom31.fields.fulfillmentGroup,
          reorderOriginalLineItemNumber: isReorder ? (_lineItem$custom32 = lineItem.custom) === null || _lineItem$custom32 === void 0 ? void 0 : _lineItem$custom32.fields.lineItemNumber : void 0
        }, ((_lineItem$custom33 = lineItem.custom) === null || _lineItem$custom33 === void 0 ? void 0 : _lineItem$custom33.fields.MMProductVersion) && (shippingCustomLineItem === null || shippingCustomLineItem === void 0 || (_shippingCustomLineIt = shippingCustomLineItem.custom) === null || _shippingCustomLineIt === void 0 ? void 0 : _shippingCustomLineIt.fields.eCommerceDeliveryOptionId) && {
          deliveryOptionId: shippingCustomLineItem.custom.fields.eCommerceDeliveryOptionId
        }), isWithFile && _objectSpread({
          userUploadsUrl: (_lineItem$custom34 = lineItem.custom) === null || _lineItem$custom34 === void 0 ? void 0 : _lineItem$custom34.fields.userUploadsUrl,
          editorType: (_lineItem$custom35 = lineItem.custom) === null || _lineItem$custom35 === void 0 ? void 0 : _lineItem$custom35.fields.editorType
        }, (((_lineItem$custom36 = lineItem.custom) === null || _lineItem$custom36 === void 0 ? void 0 : _lineItem$custom36.fields.manufacturingReadyDocumentUrl) || ((_lineItem$custom37 = lineItem.custom) === null || _lineItem$custom37 === void 0 ? void 0 : _lineItem$custom37.fields.mcpDocumentsSource)) && {
          mcpDocumentsSource: artwork === null || artwork === void 0 ? void 0 : artwork.mcpDocumentsSource,
          manufacturingReadyDocumentUrl: lineItem.custom.fields.manufacturingReadyDocumentUrl,
          mrdMetadata: lineItem.custom.fields.mrdMetadata,
          skipReview: artwork === null || artwork === void 0 ? void 0 : artwork.skipReview
        })), (_lineItem$custom38 = lineItem.custom) !== null && _lineItem$custom38 !== void 0 && _lineItem$custom38.fields.orchestrationId && lineItem.custom.fields.orchestration ? {
          orchestration: {
            id: lineItem.custom.fields.orchestrationId,
            groupId: lineItem.custom.fields.serviceGroup,
            recipient: orchestration === null || orchestration === void 0 ? void 0 : orchestration.recipient,
            serviceParams: {
              serviceKey: lineItem.custom.fields.serviceKey,
              serviceLevel: lineItem.custom.fields.serviceLevel,
              serviceType: lineItem.custom.fields.serviceType,
              serviceName: lineItem.custom.fields.serviceName
            },
            itemOrchestration: orchestration === null || orchestration === void 0 ? void 0 : orchestration.itemOrchestration
          }
        } : {}));
      })
    };
  }
};

// src/address-helper/address-helper.ts
import { keyValueObjectToStringArray as keyValueObjectToStringArray3 } from "@printdeal/transformers";
var AddressHelper = class _AddressHelper {
  static isAddressComplete(address) {
    return Boolean(address.firstName && address.lastName && address.streetName && address.streetNumber && address.postalCode && address.city && address.country);
  }
  static isShippingAddressValidOnEntity(entity) {
    var _entity$shippingAddre;
    if (!((_entity$shippingAddre = entity.shippingAddress) !== null && _entity$shippingAddre !== void 0 && _entity$shippingAddre.country)) {
      return false;
    }
    return !Boolean(EntityHelper.getMainLineItems(entity).filter(lineItem => !LineItemHelper.hasLineItemPickupPoint(lineItem)).find(lineItem => {
      var _lineItem$custom39;
      return !((_lineItem$custom39 = lineItem.custom) !== null && _lineItem$custom39 !== void 0 && (_lineItem$custom39 = _lineItem$custom39.fields.shippingAddressPerLineItem) !== null && _lineItem$custom39 !== void 0 && _lineItem$custom39.length) || lineItem.custom.fields.shippingAddressPerLineItem.find(address => {
        const parsedAddress = keyValueObjectToStringArray3(address);
        return !_AddressHelper.isAddressComplete(parsedAddress);
      });
    }));
  }
  static isShippingAddressCountryValidOnEntity(entity, validCountries) {
    if (!entity.shippingAddress) {
      return false;
    }
    if (!validCountries.includes(entity.shippingAddress.country)) {
      return false;
    }
    return !Boolean(EntityHelper.getMainLineItems(entity).filter(lineItem => !LineItemHelper.hasLineItemPickupPoint(lineItem)).find(lineItem => {
      var _lineItem$custom40;
      return !((_lineItem$custom40 = lineItem.custom) !== null && _lineItem$custom40 !== void 0 && (_lineItem$custom40 = _lineItem$custom40.fields.shippingAddressPerLineItem) !== null && _lineItem$custom40 !== void 0 && _lineItem$custom40.length) || lineItem.custom.fields.shippingAddressPerLineItem.find(address => {
        const parsedAddress = keyValueObjectToStringArray3(address);
        return !validCountries.includes(parsedAddress.country);
      });
    }));
  }
  static isBillingAddressValidOnEntity(entity) {
    if (!entity.billingAddress) {
      return false;
    }
    if (!entity.billingAddress.email) {
      return false;
    }
    return _AddressHelper.isAddressComplete(entity.billingAddress);
  }
  static isBillingAddressCountryValidOnEntity(entity, validCountries) {
    if (!entity.billingAddress) {
      return false;
    }
    return validCountries.includes(entity.billingAddress.country);
  }
  static removeCustomFieldsFromAddress(address) {
    const {
        custom
      } = address,
      rest = _objectWithoutProperties(address, _excluded2);
    if (custom) {
      return rest;
    }
    return address;
  }
};

// src/carrier-option-helper/carrier-option-helper.ts
var CarrierOptionHelper = class _CarrierOptionHelper {
  static getNumberOfCarrierOptions(options) {
    return new Set(options.map(option => option.carrier)).size;
  }
  static getTimedDeliveryFromLineItem(lineItem) {
    var _lineItem$custom41;
    if (!((_lineItem$custom41 = lineItem.custom) !== null && _lineItem$custom41 !== void 0 && _lineItem$custom41.fields.timedDelivery)) {
      return void 0;
    }
    try {
      return JSON.parse(lineItem.custom.fields.timedDelivery);
    } catch (_unused2) {
      return void 0;
    }
  }
  static getCarrierOptionFromLineItem(lineItem, options) {
    var _lineItem$custom42;
    const timedDelivery = _CarrierOptionHelper.getTimedDeliveryFromLineItem(lineItem);
    const carrierKeys = (_lineItem$custom42 = lineItem.custom) === null || _lineItem$custom42 === void 0 ? void 0 : _lineItem$custom42.fields.qpShippingCarrierKey;
    if (!timedDelivery && !carrierKeys) {
      return void 0;
    }
    if (timedDelivery) {
      if (!carrierKeys) {
        return options.find(option => option.before === timedDelivery.before);
      }
      const matchingOption = options.find(option => {
        var _option$recsKey;
        return option.before === timedDelivery.before && ((_option$recsKey = option.recsKey) === null || _option$recsKey === void 0 ? void 0 : _option$recsKey.length) === carrierKeys.length && option.recsKey.every((recsKey, index) => carrierKeys[index] === recsKey);
      });
      return matchingOption;
    }
    if (carrierKeys) {
      const matchingOption = options.find(option => {
        var _option$recsKey2;
        return ((_option$recsKey2 = option.recsKey) === null || _option$recsKey2 === void 0 ? void 0 : _option$recsKey2.length) === carrierKeys.length && option.recsKey.every((recsKey, index) => carrierKeys[index] === recsKey);
      });
      return matchingOption;
    }
  }
};

// src/entity-response-stripper-helper/entity-response-stripper-helper.ts
var EntityResponseStripperHelper = class {
  constructor(entity) {
    this.entity = entity;
  }
  strip() {
    return _objectSpread(_objectSpread({}, this.entity), {}, {
      lineItems: this.entity.lineItems.map(lineItem => _objectSpread(_objectSpread({}, lineItem), {}, {
        custom: this.stripCustomFields(lineItem)
      })),
      customLineItems: this.entity.customLineItems.map(customLineItem => _objectSpread(_objectSpread({}, customLineItem), {}, {
        custom: this.stripCustomFields(customLineItem)
      }))
    });
  }
  stripCustomFields(item) {
    const itemsToStrip = ["websiteShippingTotals", "websiteProductTotals"];
    if (!item.custom) {
      return void 0;
    }
    const newCustomFields = Object.entries(item.custom.fields).reduce((customFields, _ref4) => {
      let [key, value] = _ref4;
      if (itemsToStrip.includes(key)) {
        return customFields;
      }
      customFields[key] = value;
      return customFields;
    }, {});
    return _objectSpread(_objectSpread({}, item.custom), {}, {
      fields: newCustomFields
    });
  }
};

// src/money-helper/money-helper.ts
var MoneyHelper = class {
  static getFractionDigitsForCurrencyCode(currencyCode) {
    const fractionDigits = {
      EUR: 2,
      USD: 2,
      GBP: 2,
      JOD: 3,
      YPJ: 0
    };
    if (currencyCode in fractionDigits) {
      return fractionDigits[currencyCode];
    }
    return 2;
  }
};

// src/order-helper/order-helper.ts
var OrderHelper = class _OrderHelper {
  static hasState(order, statesKeys) {
    var _order$state;
    const stateKey = (_order$state = order.state) === null || _order$state === void 0 || (_order$state = _order$state.obj) === null || _order$state === void 0 ? void 0 : _order$state.key;
    if (!stateKey) {
      return false;
    }
    return statesKeys.includes(stateKey);
  }
  static isCancelled(order) {
    return _OrderHelper.hasState(order, ["Cancelled_order"]);
  }
  static isCancellable(order) {
    if (_OrderHelper.hasState(order, ["Open", "Processing_order", "Completed"])) {
      return true;
    }
    return order.lineItems.some(lineItem => LineItemHelper.isCancellable(lineItem));
  }
  static isChangeBillingAddressAllowed(order) {
    return !order.lineItems.some(lineItem => LineItemHelper.isShipped(lineItem));
  }
  static isPaid(order) {
    return order.paymentState === "Paid";
  }
  static getPayableInformation(order) {
    if (!order.orderNumber) {
      return {
        isPayable: false,
        notPayableReason: "ORDER_NUMBER_UNAVAILABLE"
      };
    }
    if (order.paymentState === "CreditOwed" || order.paymentState === "Paid") {
      return {
        isPayable: false,
        notPayableReason: "ORDER_PAID"
      };
    }
    const lineItemsAllCancelled = order.lineItems.every(lineItem => LineItemHelper.isCancelled(lineItem));
    if (_OrderHelper.isCancelled(order) || lineItemsAllCancelled) {
      return {
        isPayable: false,
        notPayableReason: "ORDER_CANCELLED"
      };
    }
    return {
      isPayable: true,
      notPayableReason: void 0
    };
  }
};

// src/payment-helper/payment-helper.ts
var PaymentHelper = class {
  static getPaidPayments(payments) {
    return payments.filter(_ref5 => {
      var _obj$paymentStatus$st;
      let {
        obj
      } = _ref5;
      if (!(obj !== null && obj !== void 0 && obj.paymentStatus.state)) {
        return false;
      }
      const state = (_obj$paymentStatus$st = obj.paymentStatus.state.obj) === null || _obj$paymentStatus$st === void 0 ? void 0 : _obj$paymentStatus$st.key;
      return state === "Paid" || state === "Refunded";
    });
  }
  static getPendingPayments(payments) {
    return payments.filter(_ref6 => {
      var _obj$paymentStatus$st2;
      let {
        obj
      } = _ref6;
      if (!(obj !== null && obj !== void 0 && obj.paymentStatus.state)) {
        return true;
      }
      const state = (_obj$paymentStatus$st2 = obj.paymentStatus.state.obj) === null || _obj$paymentStatus$st2 === void 0 ? void 0 : _obj$paymentStatus$st2.key;
      return state !== "Paid" && state !== "Refunded";
    });
  }
  static getTotalPaidAmount(payments) {
    return payments.reduce((acc, _ref7) => {
      let {
        obj
      } = _ref7;
      if (!obj) {
        return acc;
      }
      const chargesAmount = obj.transactions.filter(transaction => transaction.type === "Charge").reduce((sum, transaction) => sum + transaction.amount.centAmount, 0);
      const refundsAmount = obj.transactions.filter(transaction => transaction.type === "Refund").reduce((sum, transaction) => sum + transaction.amount.centAmount, 0);
      return acc + chargesAmount - refundsAmount;
    }, 0);
  }
  static getTotalPendingAmount(payments) {
    return payments.reduce((acc, payment) => {
      var _payment$obj$amountPl, _payment$obj;
      return acc + ((_payment$obj$amountPl = (_payment$obj = payment.obj) === null || _payment$obj === void 0 ? void 0 : _payment$obj.amountPlanned.centAmount) !== null && _payment$obj$amountPl !== void 0 ? _payment$obj$amountPl : 0);
    }, 0);
  }
  static getTotalRefundedAmount(transactions) {
    return transactions.filter(transaction => transaction.type === "Refund").reduce((sum, transaction) => sum + transaction.amount.centAmount, 0);
  }
  static getTotalChargedAmount(transactions) {
    return transactions.filter(transaction => transaction.type === "Charge").reduce((sum, transaction) => sum + transaction.amount.centAmount, 0);
  }
};

// src/service-helper/service-helper.ts
var ServiceHelper = class {
  static canRequestServiceChanges(entity, lineItem, serviceName) {
    if (LineItemHelper.isCancelled(lineItem)) {
      return false;
    }
    if (LineItemHelper.isArtworkDelivered(lineItem) || !LineItemHelper.isArtworkRequired(lineItem)) {
      return false;
    }
    const services = CustomLineItemHelper.getCustomLineItemsOfServiceName(entity.customLineItems, lineItem.id, [serviceName]);
    if (services.length === 0) {
      return false;
    }
    const hasActiveServices = services.some(service => {
      return CustomLineItemHelper.hasState(service, ["EditInProgress", "ServiceInProgress", "ServiceDelivered", "Cancelled"]);
    });
    return !hasActiveServices;
  }
  static isCancellable(lineItem, customLineItem) {
    if (CustomLineItemHelper.hasState(customLineItem, ["Initial", "Confirmed", "Cancelled"])) {
      return LineItemHelper.hasState(lineItem, ["WaitingForArtwork", "WaitingForDocReview", "Initial", "Processing", "WaitingForProposal", "DocReviewFailed", "DocReviewRejected", "FulfillmentRejected", "FulfillmentError", "ProcessingCloudlabArtworkFailed"]);
    }
    return false;
  }
};

// src/state-helper/state-helper.ts
var StateHelper = class _StateHelper {
  static getLineItemInProductState(states) {
    return states.filter(_ref8 => {
      let {
        key
      } = _ref8;
      return key === "ReadyForFulfillment" || key === "SentToMCP" || key === "FulfillmentAccepted" || key === "FulfillmentError" || key === "FulfillmentRejected" || key === "PrintingInProgress" || key === "DocFeedbackRequested" || key === "DocReviewApproved" || key === "DocReviewFailed" || key === "DocReviewInProgress" || key === "DocReviewInProofing" || key === "WaitingForDocReview" || key === "Held";
    });
  }
  static getLineItemState(states, neededState) {
    return states.find(_ref9 => {
      let {
        key
      } = _ref9;
      return key === neededState;
    });
  }
  static getOrderState(states, neededState) {
    return states.find(_ref10 => {
      let {
        key
      } = _ref10;
      return key === neededState;
    });
  }
  static getStatesOfType(states, stateKey) {
    switch (stateKey) {
      case "paymentNeeded":
        return [_StateHelper.getOrderState(states, "Open"), _StateHelper.getLineItemState(states, "Processing")].filter(state => Boolean(state));
      case "needsFileDelivery":
        return [_StateHelper.getLineItemState(states, "WaitingForArtwork"), _StateHelper.getLineItemState(states, "DocReviewRejected")].filter(state => Boolean(state));
      case "inProduction":
        return [_StateHelper.getLineItemState(states, "ReadyForFulfillment"), _StateHelper.getLineItemState(states, "SentToMCP"), _StateHelper.getLineItemState(states, "FulfillmentAccepted"), _StateHelper.getLineItemState(states, "FulfillmentError"), _StateHelper.getLineItemState(states, "FulfillmentRejected"), _StateHelper.getLineItemState(states, "PrintingInProgress"), _StateHelper.getLineItemState(states, "DocFeedbackRequested"), _StateHelper.getLineItemState(states, "DocReviewApproved"), _StateHelper.getLineItemState(states, "DocReviewFailed"), _StateHelper.getLineItemState(states, "DocReviewInProgress"), _StateHelper.getLineItemState(states, "WaitingForDocReview"), _StateHelper.getLineItemState(states, "Held")].filter(state => Boolean(state));
      case "shipped":
        return [_StateHelper.getLineItemState(states, "Shipped")].filter(state => Boolean(state));
      case "cancelled":
        return [_StateHelper.getLineItemState(states, "Cancelled")].filter(state => Boolean(state));
      case "docReviewInProofing":
        return [_StateHelper.getLineItemState(states, "DocReviewInProofing")].filter(state => Boolean(state));
      default:
        return [];
    }
  }
};

// src/surface-helper/surface-helper.ts
var SurfaceHelper = class _SurfaceHelper {
  static filterRemainingOptions(options, userSelections) {
    return options.filter(option => userSelections[option]);
  }
  static shouldRemoveArtwork(options, currentUserSelection, newUserSelection) {
    return _SurfaceHelper.filterRemainingOptions(options, newUserSelection).some(option => {
      const currentValue = currentUserSelection[option];
      const newValue = newUserSelection[option];
      if (!currentValue || !newValue) {
        return true;
      }
      return currentValue.toLowerCase() !== newValue.toLowerCase();
    });
  }
};

// src/uuid-helper/uuid-helper.ts
var UUIDHelper = class {
  static generate() {
    return crypto.randomUUID();
  }
  static validate(uuid) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(uuid);
  }
};

// src/validation-helper/validation-helper.ts
import { arrayOfStringArraysToArrayOfObjects as arrayOfStringArraysToArrayOfObjects2 } from "@printdeal/transformers";
import { klona } from "klona";
import { ZodError } from "zod";

// src/validation-helper/schemas/cart-schema.ts
import { z as z4 } from "zod";

// src/validation-helper/schemas/billing-address-schema.ts
import { z } from "zod";

// src/validation-helper/validation-functions.ts
var validatePostalCode = context => {
  const {
    country,
    postalCode
  } = context.value;
  if (country.toLowerCase() === "nl") {
    if (!postalCode.match(/^[1-9][0-9]{3}\s*?[a-zA-Z]{2}$/)) {
      context.issues.push({
        code: "custom",
        input: postalCode,
        message: 'postalCode must match the following: "/^[1-9][0-9]{3}\\s*?[a-zA-Z]{2}$/"',
        path: ["postalCode"]
      });
    }
  } else {
    if (!postalCode || postalCode.length < 1) {
      context.issues.push({
        code: "custom",
        input: postalCode,
        message: "Postal code is required",
        path: ["postalCode"]
      });
    }
    if (!postalCode.match(/^[0-9a-zA-Z\s-]*$/)) {
      context.issues.push({
        code: "custom",
        input: postalCode,
        message: 'postalCode must match the following: "/^[0-9a-zA-Z\\s-]*$/"',
        path: ["postalCode"]
      });
    }
  }
};

// src/validation-helper/schemas/billing-address-schema.ts
var billingAddressSchema = z.looseObject({
  country: z.string().trim().length(2),
  postalCode: z.string().trim(),
  streetNumber: z.string().trim().max(100),
  streetName: z.string().trim().max(100),
  city: z.string().trim().max(100),
  firstName: z.string().trim().max(75).optional(),
  lastName: z.string().trim().max(150).optional(),
  phone: z.string().trim().optional(),
  email: z.email().max(255),
  company: z.string().trim().max(255).optional()
}).check(validatePostalCode);

// src/validation-helper/schemas/line-items-schema.ts
import { z as z3 } from "zod";

// src/validation-helper/schemas/shipping-address-schema.ts
import { z as z2 } from "zod";
var shippingAddressSchema = z2.looseObject({
  postalCode: z2.string().trim(),
  country: z2.string().trim().length(2),
  streetNumber: z2.string().trim().max(100),
  streetName: z2.string().trim().max(100),
  city: z2.string().trim().max(100),
  firstName: z2.string().trim().max(75).refine(value => value !== "*", {
    message: "Cannot be an *."
  }),
  lastName: z2.string().trim().max(150).refine(value => value !== "*", {
    message: "Cannot be an *."
  }),
  phone: z2.string().trim().optional(),
  company: z2.string().trim().max(255).refine(value => value !== "*", {
    message: "Cannot be an *."
  }).optional()
}).check(validatePostalCode);

// src/validation-helper/schemas/line-items-schema.ts
var lineItemsSchema = z3.looseObject({
  id: z3.string(),
  custom: z3.looseObject({
    fields: z3.looseObject({
      shippingAddressPerLineItem: z3.array(shippingAddressSchema).optional(),
      isWithPickupLocation: z3.boolean().optional()
    }).refine(fields => {
      if (fields.isWithPickupLocation) {
        return true;
      }
      return fields.shippingAddressPerLineItem && fields.shippingAddressPerLineItem.length > 0;
    }, {
      message: "Shipping address per line item is required and must be valid when not using pickup location",
      path: ["shippingAddressPerLineItem"]
    })
  }).required()
});

// src/validation-helper/schemas/cart-schema.ts
var cartSchema = z4.looseObject({
  lineItems: z4.array(lineItemsSchema),
  shippingAddress: z4.looseObject({
    country: z4.string().trim().length(2)
  }),
  billingAddress: billingAddressSchema,
  custom: z4.looseObject({
    fields: z4.looseObject({}).required()
  })
});

// src/validation-helper/validation-helper.ts
var ValidationHelper = class {
  static async validateEntity(entity) {
    const transformEntityForValidation = () => {
      const transformedCart = klona(entity);
      transformedCart.lineItems = transformedCart.lineItems.map(lineItem => {
        var _lineItem$custom43;
        if ((_lineItem$custom43 = lineItem.custom) !== null && _lineItem$custom43 !== void 0 && _lineItem$custom43.fields.shippingAddressPerLineItem) {
          const {
            shippingAddressPerLineItem
          } = lineItem.custom.fields;
          return _objectSpread(_objectSpread({}, lineItem), {}, {
            custom: _objectSpread(_objectSpread({}, lineItem.custom), {}, {
              fields: _objectSpread(_objectSpread({}, lineItem.custom.fields), {}, {
                shippingAddressPerLineItem: arrayOfStringArraysToArrayOfObjects2(shippingAddressPerLineItem)
              })
            })
          });
        }
        return lineItem;
      });
      return transformedCart;
    };
    try {
      cartSchema.parse(transformEntityForValidation());
    } catch (error) {
      if (error instanceof ZodError) {
        const rejection = {
          errorMessage: {
            statusCode: 400,
            message: "Invalid cart!",
            errors: error.issues.map(issue => ({
              path: issue.path.join("."),
              message: issue.message
            })).filter((value, index, self) => self.findIndex(v => v.path === value.path && v.message === value.message) === index)
          }
        };
        return Promise.reject(rejection);
      }
      return Promise.reject(error);
    }
    return "No errors";
  }
};
export { ActionHelper, AddLineItemHelper, AddressHelper, CarrierOptionHelper, CustomLineItemHelper, EntityHelper, EntityResponseStripperHelper, LineItemHelper, MoneyHelper, OrderHelper, PaymentHelper, ServiceHelper, StateHelper, SurfaceHelper, UUIDHelper, ValidationHelper };